import dayjs from 'dayjs';
import { P } from '../../theme/tokens';

export const STATUSES = [
  { key: 'Under Application / Prospect', color: P.info },
  { key: 'Draft', color: P.purple },
  { key: 'Active', color: P.success },
  { key: 'Active - Notice Given', color: P.warning },
  { key: 'Terminated', color: P.subtle }
];

export const colorOf = (status) => STATUSES.find((s) => s.key === status)?.color || P.subtle;

const LEGACY = { qualified: 'Draft', leased: 'Active', lost: 'Terminated' };

export const statusOf = (c) => c.tenantStatus || LEGACY[c.status] || 'Active';

export const propertyOf = (c) => c.unit?.name || c.interestedProperty || '—';

export const agentOf = (c) => c.assignedTo || 'Unassigned';

export const lastContact = (c) => {
  const at = c.lastContactAt || c.createdAt;
  if (!at) return '—';
  const d = dayjs(at);
  return d.isSame(dayjs(), 'day') ? `Today, ${d.format('h:mm A')}` : d.format('MMM D');
};
